import React, { useEffect } from "react";
import "./OrderSuccesFullModal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "../../../Animation/Successfull_Lottie/Successfull_Lottie";
import Brown_Success_Lottie from "../../../Animation/Brown_Success_Lottie/Brown_Success_Lottie";
import Order_Successfull_Lottie from "../../../Animation/Order_Successfull_Lottie/Order_Successfull_Lottie";

function OrderSuccesFullModal({ baseLink, ...props }) {
    
  setTimeout(() => {
    props?.onHide();
  }, 5000);

  return (
    <>
      <section className="OrderSuccesFullModal modal-holder">
        <Modal
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="OrderSuccesFullModal modal-holder"
        >
          <Modal.Body>
            <div className="success_main_div">
              <div className="success_loottie_holder">
                <Order_Successfull_Lottie />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">{props?.successText}</p>

                  {props?.successText2 && (
                    <p className="heading">{props?.successText2}</p>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default OrderSuccesFullModal;
